import { IModalDescription, IModalProps, IModalResolver } from '@cp/shared/modal';
import { PROFILE_DELETE_MODAL } from 'src/features/client/delete';
import {
  CARD_BINDING_MODAL,
  CHECKOUT_MODAL,
  COPY_PROMO_MODAL,
  SUBSCRIPTION_CONFIRM_MODAL,
  TARIFF_SELECT_MODAL,
} from 'src/features/billing';
import { REGISTRATION_MODAL } from 'src/features/registration';

const modalDict = new Map<string, IModalDescription<any>>([
  [PROFILE_DELETE_MODAL.nss, PROFILE_DELETE_MODAL],
  [TARIFF_SELECT_MODAL.nss, TARIFF_SELECT_MODAL],
  [COPY_PROMO_MODAL.nss, COPY_PROMO_MODAL],
  [SUBSCRIPTION_CONFIRM_MODAL.nss, SUBSCRIPTION_CONFIRM_MODAL],
  [CARD_BINDING_MODAL.nss, CARD_BINDING_MODAL],
  [CHECKOUT_MODAL.nss, CHECKOUT_MODAL],
  [REGISTRATION_MODAL.nss, REGISTRATION_MODAL],
]);

export const modalResolver: IModalResolver = {
  resolve<M extends IModalDescription<P>, P extends IModalProps<Parameters<P['onSuccess']>[0]>>(modal: M) {
    return modal.loader();
  },
  resolveComponent: (name: string) => {
    if (!modalDict.has(name)) {
      console.debug(`ModalResolver: Name ${name} is not in modal dict. Resolve from shared/components/modals`);
      return import(`../../shared/components/modals/${name}`).then((module) => module.default);
    }
    const MODAL_DESCRIPTION = modalDict.get(name) as IModalDescription<any>;
    return MODAL_DESCRIPTION.loader();
  },
};
